import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';
import ROOT_URL from "../../Utilities/apiconfig";
import ContactMarquee from '../Pages/ContactMarquee';

const getRandomLightColor = () => {
  const colors = [
    "#f8f9fa", "#e3f2fd", "#f1f8e9", "#fff3e0", "#fbe9e7",
    "#ede7f6", "#e0f7fa", "#e8f5e9", "#ffecb3", "#c8e6c9"
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

const DepartmentsHome = () => {
  const [departments, setDepartments] = useState([]);
  const [bgColors, setBgColors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get(`${ROOT_URL}/api/departments`);
        setDepartments(response.data);
        setBgColors(response.data.map(() => getRandomLightColor())); // Assign random colors to each department
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch departments data');
        setLoading(false);
      }
    };
    fetchDepartments();
  }, []);

  if (loading) return <p>Loading departments...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div>
      <Helmet>
        <title>Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Hospital Departments</title>
        <meta name="description" content="Explore hospital departments at Columbiaa Hospital, Kasturi Nagar, Bangalore. Best multi-speciality hospital offering cardiology, neurology, neurosurgery, orthopedics, oncology, nephrology, obstetrics and gynaecology, gastroenterology, ENT, dermatology, pulmonology, urology, and more. Expert doctors and advanced treatments." />
        <meta name="keywords" content="Columbiaa Hospital, hospital departments, best multi-speciality hospital, hospital in Kasturi Nagar, hospital in Bangalore, cardiology department, neurology department, neurosurgery department, orthopedics department, oncology department, nephrology department, dialysis department, obstetrics and gynaecology, gastroenterology, ENT department, dermatology, pulmonology, urology, emergency medicine, critical care, anesthesiology, plastic surgery, psychiatry, physiotherapy, dental hospital, Bangalore hospital, 24/7 hospital, top hospital near me, multi-speciality hospital near me, hospital near Kasturi Nagar, healthcare Bangalore, specialist doctor Bangalore, Dr H V Satish Babu" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Hospital Departments" />
        <meta property="og:description" content="Explore all hospital departments at Columbiaa Hospital, the best multi-speciality hospital in Kasturi Nagar, Bangalore. Expert care in cardiology, neurology, orthopedics, oncology and more." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/departments" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/departments" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>

            <section className="mt-5 pt-5 text-center" aria-label="Departments Overview Section">
          <div className="container-fluid px-4" data-aos="fade-right">
            <div className="sec-title">
              <span className="top-title">Our Departments</span>
              <h2 style={{ fontSize: "44px" }}>Expertise Across Multiple Specialties</h2>
              <p>
                Columbiaa Multispeciality Hospital Healing Touch With Complete Healthcare. Our hospital aims to give complete professional, 
                <br />courteous, and dedicated healthcare services to the local and extended community with compassion and competence.
              </p>
            </div>
          </div>
        </section>
        
        <div className="container" aria-label="List of Hospital Departments">
          <div className="row">
            {departments.map((dept, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
                <article
                  className="d-flex flex-column overflow-hidden"
                  style={{
                    backgroundColor: bgColors[index],
                    textAlign: "center",
                    height: "100%",
                    borderRadius: "25px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    transition: "0.3s ease-in-out",
                  }}
                  aria-label={`Department: ${dept.departmentName}`}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "100px",
                      borderRadius: "25px 25px 0 0",
                      overflow: "hidden",
                    }}
                    data-aos="fade-down-left"
                  >
                    <img
                      src={`${ROOT_URL}/uploads/departments/${dept.image}`}
                      alt={`Image representing ${dept.departmentName}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "25px 25px 0 0",
                      }}
                    />
                  </div>
        
                  <div className="p-3" data-aos="fade-right">
                    <h4 className="fw-bold mb-2" style={{ fontSize: "20px", fontWeight: "bold" }}>
                      {dept.departmentName}
                    </h4>
                    <p style={{ fontSize: "14px", color: "#555", marginBottom: "0" }}>{dept.description}</p>
                    <button
                              className="btn btn-success mt-2"
                              style={{
                                // backgroundColor: "#007bff",
                                borderRadius: "8px",
                                padding: "8px 12px",
                                width: "100%",
                              }}
                              onClick={() => navigate(`/book-appointment`)}
                             
                            >
                              Book Appointment
                            </button>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
        {/* <ContactMarquee/> */}
    </div>
  )
}

export default DepartmentsHome